import utils from './utils';

export default (function () {
    const proptypes = {

        /**
         * Validates if the array is equal to the expected length.
         *
         * @param {number} expectedLength
         */
        arrayIsEqualTo: function (expectedLength) {
            if (expectedLength === null) {
                throw new Error('expectedLength for the function isEqualTo has not been defined.');
            }

            if (!utils.isNumber(expectedLength)) {
                throw new Error('expectedLength for the function isEqualTo has to be a number.');
            }

            return function (props, propName, componentName) {
                const arrayLength = props[propName].length;

                if (arrayLength !== expectedLength) {
                    throw new Error(
                        `Invalid array length ${ arrayLength } (expected ${ expectedLength }) for prop ${ propName } supplied to ${ componentName }.`
                    );
                }
            };
        },
    };

    return proptypes;
})();



// WEBPACK FOOTER //
// ./src/helpers/proptypes.js